export default function hoverMenuItem() {
   let initialized = false;
   let hoverImagesContainer = null;
   let hoverImage = null;

   const initHoverImages = () => {
       if (initialized || window.innerWidth < 1401) return;

       const navLinks = document.querySelectorAll('.main-menu .wp-block-navigation a[data-hover-image]');
       if (navLinks.length === 0) return;

       hoverImagesContainer = document.querySelector('.hover-images-container');

       if (!hoverImagesContainer) {
           hoverImagesContainer = document.createElement('div');
           hoverImagesContainer.classList.add('hover-images-container');

           const menuContainer = document.querySelector('.header__menu') || document.body;
           menuContainer.appendChild(hoverImagesContainer);

           hoverImage = document.createElement('img');
           hoverImage.classList.add('hover-preview-img');
           hoverImagesContainer.appendChild(hoverImage);
       } else {
           hoverImage = hoverImagesContainer.querySelector('.hover-preview-img');
       }

       navLinks.forEach(link => {
           const imgUrl = link.getAttribute('data-hover-image');

           if (imgUrl) {
               link.addEventListener('mouseenter', () => {
                   hoverImage.src = imgUrl;
                   hoverImagesContainer.style.display = 'block';
               });

               link.addEventListener('mouseleave', () => {
                   hoverImagesContainer.style.display = 'none';
               });
           }
       });

       initialized = true;
   };

   const destroyHoverImages = () => {
       if (hoverImagesContainer) {
           hoverImagesContainer.remove();
           hoverImagesContainer = null;
           hoverImage = null;
       }
       initialized = false;
   };

   const handleResize = () => {
       if (window.innerWidth >= 1401) {
           initHoverImages();
       } else {
           destroyHoverImages();
       }
   };

   handleResize();
   window.addEventListener('resize', handleResize);
}
